(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-quotes"] && !Shopify.designMode) return;
  try {
    
  class PressQuotes extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-press-slide]'));
      this.buttons = Array.from(this.querySelectorAll('[data-press-target]'));
      this.current = 0;
      this.autoplay = this.dataset.autoplay === 'true';
      this.delay = Number(this.dataset.autoplaySpeed) || 8000;

      this.buttons.forEach((button) => {
        button.addEventListener('click', this.onLogoClick);
      });

      this.addEventListener('mouseenter', this.stop);
      this.addEventListener('mouseleave', this.start);
      document.addEventListener('visibilitychange', this.onVisibilityChange);

      this.select(this.current);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      this.buttons?.forEach((button) => {
        button.removeEventListener('click', this.onLogoClick);
      });
      this.removeEventListener('mouseenter', this.stop);
      this.removeEventListener('mouseleave', this.start);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }

    onLogoClick = (event) => {
      this.select(Number(event.currentTarget.dataset.pressTarget) || 0);
      this.restart();
    };

    onVisibilityChange = () => {
      if (document.hidden) {
        this.stop();
        return;
      }

      this.start();
    };

    clamp(index) {
      if (!this.slides.length) return 0;
      if (index < 0) return this.slides.length - 1;
      if (index >= this.slides.length) return 0;
      return index;
    }

    select(index) {
      this.current = this.clamp(index);

      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.current;
        slide.hidden = !active;
        slide.setAttribute('aria-hidden', String(!active));
      });

      this.buttons.forEach((button, buttonIndex) => {
        button.setAttribute('aria-selected', String(buttonIndex === this.current));
      });
    }

    start = () => {
      if (!this.autoplay || this.slides.length < 2 || this.interval) return;

      this.interval = setInterval(() => {
        this.select(this.current + 1);
      }, this.delay);
    };

    stop = () => {
      clearInterval(this.interval);
      this.interval = undefined;
    };

    restart() {
      this.stop();
      this.start();
    }
  }

  if (!customElements.get('press-quotes')) {
    customElements.define('press-quotes', PressQuotes);
  }

  } catch(e) { console.error(e); }
})();
})();
